import HeaderPage from "../../components/lines-managements/header/HeaderPage";
import EsimPartnersList from "../../components/esim-partners";
import useCan from "../../components/users/permissions/useCan";

const EsimPartners: React.FC = () => {
  const can = useCan("esim.partner.partner.create");
  return (
    <>
      <HeaderPage
        {...(can && {
          link: {
            to: "add",
            children: "Shto partner te ri",
            state: ["Partneret eSIM", "Shto partner te ri"]
          }
        })}
      />
      <EsimPartnersList />
    </>
  );
};

export default EsimPartners;
